export default __webpack_public_path__ + "static/superstructure_b.75b70c22cb9fe9b69c755f85575273ce.svg";